import { useEffect, useState } from "react";
import { t } from "../../translations";

import { Aa } from "../functions/Aa";
import "../styles/section-chef.css";

import { TiDelete, TiLocation } from "react-icons/ti";

import { GET, POST, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";

import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { POST_TO_CART_GLOCERY, POST_USER_DATA } from "../../store/action";

import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import Menu from "@mui/material/Menu";
import { styled } from "@mui/material/styles";
import { openNotificationWithIcon } from "./notification-bar";

import CartIcon from "../../assets/cart-icon.png";
import LocIcon from "../../assets/loc-icon.png";

import { Typography } from "antd";
import { BsArrowLeft, BsPlus, BsSearch } from "react-icons/bs";
import { FaMinus } from "react-icons/fa";
import { todayDate } from "../functions/dateFunctions";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutFormGlocery from "./checkoutFormGlocery";

import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { translateErrorMessage } from "../../utils/errorMessageTranslator";
import { createLogger } from "../../utils/logger";

const logger = createLogger("SelectGlocery");
const stripePromise = loadStripe(
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_PROD
    : process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_TEST
);

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0
  },
  "&:before": {
    display: "none"
  }
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)"
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1)
  }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)"
}));

const SelectGlocery = (props) => {
  const { user, lang, selectedZip } = props;
  const [selectedValue, setSelectedValue] = useState("market");
  const [shopValue, setShopValue] = useState("");
  const [itemValue, setItemValue] = useState("");
  const [categoryValue, setCategoryValue] = useState("");
  const [expanded, setExpanded] = useState("");
  const [order, setOrder] = useState([]);
  const [load, setLoad] = useState(false);
  const [openWaring, setOpenWarning] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [partnerId, setPartnerId] = useState(null);
  const [checkoutPage, setCheckoutPage] = useState(false);
  const [newZip, setNewZip] = useState("");
  const [gloceries, setGloceries] = useState([]);
  const [items, setItems] = useState([]);
  const [itemsNew, setNewItems] = useState([]);
  const [category, setCategory] = useState([]);
  const [showItems, setShowItems] = useState(false);
  const [showCategory, setShowCategory] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const [address, setAddress] = useState({
    receiver_name: "",
    phone_number: "",
    street_name: "",
    line_address: "",
    instruction: "",
    lat: null,
    lng: null
  });

  const [open, setOpen] = useState(false);

  const [deliveryDetail, setDeliveryDetail] = useState(0);

  const cart_glocery = useSelector((state) => state.cart_glocery);

  const openZip = Boolean(anchorEl);

  const dispatch = useDispatch();

  const post_user_data = (data) => {
    dispatch(post_user(data));
  };

  const post_to_cart_glocery = (data) => {
    dispatch(post_cart_glocery(data));
  };

  const add_remove_cart = (data) => {
    if (
      cart_glocery.length > 0 &&
      cart_glocery.filter((item) => {
        return item?.glocery_partner === data.glocery_partner;
      }).length === 0
    ) {
      // here is cart_glocery clear
      return setOpenWarning(true);
    }

    if (
      cart_glocery.filter((item) => {
        return item._id === data._id;
      })[0]
    ) {
      return post_to_cart_glocery(
        [...cart_glocery].filter(({ _id }) => _id !== data._id)
      );
    }

    return post_to_cart_glocery([...cart_glocery, { ...data, qty: 1 }]);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    initialData();
  }, []);

  async function handleConvert(text) {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          text
        )}&key=${process.env.REACT_APP_API_KEY_MAP}`
      );
      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry.location;
        setAddress({ ...address, street_name: text, lat, lng });
        logger.log("Done");
      } else {
        setAddress({ ...address, lat: null, lng: null });
        logger.log("Not Done");
      }
    } catch (error) {
      logger.error("Error:", error);
      setAddress({ ...address, lat: null, lng: null });
      logger.log("Not Done");
    }
  }

  const initialData = async () => {
    setLoad(true);
    const request_details_gloceries = {
      type: GET,
      url: service_api,
      route: `glocery-partner/get-actif-gloceries`,
      data: null,
      token: user?.refresh_token
    };

    const request_details_categories = {
      type: GET,
      url: service_api,
      route: `category/get-actif`,
      data: null,
      token: user?.refresh_token
    };

    const request_details_orders = {
      type: GET,
      url: service_api,
      route: `order-glocery/get-chef-orders/${user?._id}`,
      data: null,
      token: user?.refresh_token
    };

    try {
      const [
        response_gloceries,
        response_categories,
        response_orders
      ] = await Promise.all([
        MakeRequestAsync(request_details_gloceries),
        MakeRequestAsync(request_details_categories),
        MakeRequestAsync(request_details_orders)
      ]);

      const decryptedDataGloceries = decryptSingleData(
        response_gloceries.data.glocery_partner
      );
      setGloceries(decryptedDataGloceries);

      const decryptedDataCategories = decryptSingleData(
        response_categories.data.category
      );
      setCategory(decryptedDataCategories);

      const decryptedDataOrders = decryptSingleData(
        response_orders.data.order
      );
      setOrder(decryptedDataOrders);
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  const getGloceryCategory = async (id) => {
    setLoad(true);
    const request_details_items = {
      type: GET,
      url: service_api,
      route: `glocery-item/get-actif-category/${id}`,
      data: null,
      token: user?.refresh_token
    };
    try {
      const response = await MakeRequestAsync(request_details_items);
      const decryptedData = decryptSingleData(response.data.glocery_item);
      setItems(decryptedData);
      setNewItems(
        decryptedData?.filter((item) => {
          logger.log(item?.category, id);
          return item.category === id;
        })
      );
      setShowItems(false);
      setShowCategory(true);
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  const goToItems = (id) => {
    setLoad(true);

    setNewItems(
      items?.filter((item) => {
        return item.category === id;
      })
    );

    setShowCategory(false);
    setShowItems(true);

    setLoad(false);
  };

  const addAddress = async () => {
    if (
      address?.receiver_name.length === 0 ||
      address?.phone_number.length === 0 ||
      address?.street_name.length === 0 ||
      address?.line_address.length === 0 ||
      address?.instruction.length === 0
    ) {
      return openNotificationWithIcon(
        "error",
        t("select_grocery.errors.address_required", lang)
      );
    }

    if (address?.lat === null || address?.lng === null) {
      return openNotificationWithIcon(
        "error",
        t("select_grocery.errors.position_error", lang)
      );
    }

    setLoad(true);

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `user/update-user/${user?._id}`,
      data: {
        address: [...user?.address, address]
      },
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      const decryptedData = decryptSingleData(response.data.user);
      post_user_data({
        ...decryptedData
      });
      openNotificationWithIcon("success", t("success.address_added", lang));
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
      return openNotificationWithIcon(
        "error",
        t("select_grocery.errors.profile_update_error", lang)
      );
    } finally {
      setLoad(false);
    }
  };

  const addressUpdate = async (number) => {
    setLoad(true);

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `user/update-user/${user?._id}`,
      data: {
        address: user?.address?.filter((item, index) => {
          return index !== number;
        })
      },
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      const decryptedData = decryptSingleData(response.data.user);
      post_user_data({
        ...decryptedData
      });
      openNotificationWithIcon("success", t("success.address_removed", lang));
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
      return openNotificationWithIcon(
        "error",
        t("select_grocery.errors.profile_update_error", lang)
      );
    } finally {
      setLoad(false);
    }
  };

  const getDateInFull = () => {
    const options = {
      weekday: "long", // Full day of the week name
      year: "numeric",
      month: "long", // Full month name
      day: "numeric"
    };

    const locale = "fr-FR"; // French locale

    const currentDate = new Date().toLocaleDateString(locale, options);

    return currentDate;
  };

  const loadPaymentPage = async () => {
    if (user?.street.length === 0 || user?.zip.length === 0) {
      return openNotificationWithIcon(
        "error",
        t("buttons.set_your_delive", lang)
      );
    }

    if (user.address.length === 0) {
      return openNotificationWithIcon(
        "error",
        t("buttons.set_a_delivery_", lang)
      );
    }
    setLoad(true);

    const request_details = {
      type: POST,
      url: service_api,
      route: `order-glocery/create-order`,
      data: {
        food: cart_glocery,
        billing_details: {
          amount: cart_glocery?.reduce((a, b) => a + b?.cost * b?.qty, 0),
          // earned_chef, earned_pani, delivery_price (has to be handle at the backend side)
          delivery_date: todayDate()
        },
        delivery_details: {
          ...user?.address[deliveryDetail],

          lat: null,
          lng: null
        },
        chef_id: user?._id,
        glocery_id: cart_glocery[0].glocery_partner
      },
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);

      let encrypted = decryptSingleData(response.data.order_id);
      setOrderId(encrypted);
      return setCheckoutPage(true);
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
      // Display the backend error message if available, otherwise show generic error
      const backendMessage = err?.response?.data?.message;
      const errorMessage = backendMessage
        ? translateErrorMessage(backendMessage, lang, user?.restaurant)
        : t("select_grocery.errors.order_error", lang);
      return openNotificationWithIcon("error", errorMessage);
    } finally {
      setLoad(false);
    }
  };

  return (
    <div className="section-chef-menu-right-profil">
      <div className="section-chef-menu-right-profil-inside">
        <div
          className="section-chef-menu-right-profil-inside-box"
          style={{
            marginTop: 10
          }}
        >
          <div
            className="section-chef-menu-right-profil-inside-left"
            style={{
              width: "100%"
            }}
          >
            <p
              style={
                {
                  // fontSize: 25
                }
              }
            >
              {t("common.groceries", lang)}
            </p>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                gap: 10
              }}
            >
              {[
                {
                  text: t("common.market"),
                  value: "market"
                },
                {
                  text: t("commerce.my_orders_2"),
                  value: "orders"
                }
              ].map((item) => (
                <p
                  style={{
                    fontSize: 18,
                    width: "47%",
                    textAlign: "center",
                    padding: 10,
                    borderBottom: `3px solid ${
                      selectedValue === item?.value ? "#ff114d" : "#fff"
                    }`,
                    cursor: "pointer"
                  }}
                  onClick={() => {
                    setSelectedValue(item.value);
                  }}
                >
                  {item?.text}
                </p>
              ))}
            </div>
            {load && (
              <CircularProgress
                style={{
                  marginTop: 10
                }}
              />
            )}
            {!load &&
              // items.length === 0 &&
              selectedValue === "market" &&
              !showItems &&
              !showCategory &&
              !showCart &&
              !checkoutPage && (
                <div
                  style={{
                    width: "100%",
                    border: "1px solid #eeeeee",
                    padding: 10,
                    borderRadius: 5,
                    marginTop: 5
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: 10
                    }}
                    className="glocery-block-menu"
                  >
                    <div
                      style={{

                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        alignItems: "center"
                      }}
                      className="zip-glocery-select"
                      onClick={handleClick}
                    >
                      <img
                        src={LocIcon}
                        style={{
                          width: 40
                        }}
                        alt="icon-logo"
                      />
                      <span
                        style={{
                          fontSize: 16,
                          color: "#000"
                        }}
                      >
                        {selectedZip}
                      </span>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        alignItems: "center",
                        height: 48,
                        justifyContent: "center",
                        border: "1px solid #e3e3e3",
                        borderRadius: 22,
                        backgroundColor: "#f7f7f7",
                        paddingLeft: 10
                      }}
                    >
                      <BsSearch size={25} color="gray" />
                      <input
                        placeholder={t("select_grocery.looking_for_shop", lang)}
                        value={shopValue}
                        onChange={(e) => {
                          setShopValue(e.target.value);
                        }}
                        style={{
                          width: "95%",
                          border: "0px",
                          height: 44,
                          borderRadius: 22,
                          backgroundColor: "#f7f7f7",

                          fontSize: 18
                        }}
                      />
                    </div>
                    <div
                      style={{}}
                      className="zip-glocery-select"
                      onClick={() => {
                        if (cart_glocery.length === 0) {
                          return;
                        }
                        setShowCart(true);
                      }}
                    >
                      {cart_glocery.length === 0 && (
                        <img
                          src={CartIcon}
                          style={{
                            objectFit: "contain"
                          }}
                          alt="icon-cart"
                        />
                      )}

                      {cart_glocery.length > 0 && (
                        <div
                          style={{
                            width: 40,
                            height: 40,
                            backgroundColor: "#FF114D",
                            borderRadius: 25,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: 18,
                            fontWeight: "500",
                            color: "#fff"
                          }}
                        >
                          {cart_glocery.length}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="partners-block-display">
                    {gloceries
                      ?.filter((item) => {
                        if (shopValue.length > 0) {
                          return item?.company_name
                            ?.toLowerCase()
                            .includes(shopValue.toLowerCase());
                        }
                        return item;
                      })
                      ?.map((item) => (
                        <div
                          className="partner-item"
                          onClick={() => {
                            setPartnerId(item?._id);
                            getGloceryCategory(item?._id);
                          }}
                        >
                          <img src={item?.pic} alt="partner-logo" />
                          <span
                            style={{
                              fontSize: 15,
                              fontWeight: "bold",
                              color: cart_glocery.filter((data) => {
                                return data.glocery_partner === item._id;
                              })[0]
                                ? "blue"
                                : "#000"
                            }}
                          >
                            {item?.company_name?.length > 30
                              ? item?.company_name?.slice(0, 30) + "..."
                              : item?.company_name}
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            {!load &&
              // items.length > 0 &&
              selectedValue === "market" &&
              !showItems &&
              showCategory &&
              !showCart &&
              !checkoutPage && (
                <div
                  style={{
                    width: "100%",
                    border: "1px solid #eeeeee",
                    padding: 10,
                    borderRadius: 5,
                    marginTop: 5
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      gap: 10
                    }}
                    className="glocery-block-menu"
                  >
                    <div
                      style={{

                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        alignItems: "center"
                      }}
                      className="zip-glocery-select"
                      onClick={handleClick}
                    >
                      <img
                        src={LocIcon}
                        style={{
                          width: 40
                        }}
                        alt="icon-logo"
                      />
                      <span
                        style={{
                          fontSize: 16,
                          color: "#000"
                        }}
                      >
                        {selectedZip}
                      </span>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        alignItems: "center",
                        height: 48,
                        justifyContent: "center",
                        border: "1px solid #e3e3e3",
                        borderRadius: 22,
                        backgroundColor: "#f7f7f7",
                        paddingLeft: 10
                      }}
                    >
                      <BsSearch size={25} color="gray" />
                      <input
                        placeholder={t("common.looking_for_a_c", lang)}
                        value={categoryValue}
                        onChange={(e) => {
                          setCategoryValue(e.target.value);
                        }}
                        style={{
                          width: "95%",
                          border: "0px",
                          height: 44,
                          borderRadius: 22,
                          backgroundColor: "#f7f7f7",

                          fontSize: 18
                        }}
                      />
                    </div>
                    <div
                      style={{}}
                      className="zip-glocery-select"
                      onClick={() => {
                        if (cart_glocery.length === 0) {
                          return;
                        }
                        setShowCart(true);
                      }}
                    >
                      {cart_glocery.length === 0 && (
                        <img
                          src={CartIcon}
                          style={{
                            objectFit: "contain"
                          }}
                          alt="icon-cart"
                        />
                      )}

                      {cart_glocery.length > 0 && (
                        <div
                          style={{
                            width: 40,
                            height: 40,
                            backgroundColor: "#FF114D",
                            borderRadius: 25,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: 18,
                            fontWeight: "500",
                            color: "#fff"
                          }}
                        >
                          {cart_glocery.length}
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      marginTop: 10
                    }}
                    onClick={() => {
                      // setItems([]);
                      setShowCategory(false);
                      setShowItems(false);
                    }}
                  >
                    <BsArrowLeft style={{ marginLeft: 10 }} size={30} />
                  </div>
                  <div className="partners-block-display">
                    <div
                      style={{
                        width: "100%",
                        marginTop: 10,
                        display: "flex",
                        justifyContent: "center"
                      }}
                    >
                      {category.length === 0 && (
                        <h4>{t("select_grocery.no_category_found", lang)} </h4>
                      )}
                    </div>
                    {category
                      ?.filter((item) => {
                        return items?.some((e) => e.category === item._id);
                      }) // Filter items that exist in the 'items' array
                      ?.filter((item) => {
                        if (!categoryValue) return true; // Return all items if no categoryValue is provided
                        return item?.name
                          ?.toLowerCase()
                          .includes(categoryValue.toLowerCase());
                      })
                      ?.map((item) => (
                        <div
                          className="partner-item"
                          onClick={() => {
                            goToItems(item?._id);
                            // getGloceryItems(partnerId, item?._id);
                          }}
                        >
                          <img
                            src={item?.icon}
                            style={{
                              width: "100%",
                              height: 120,
                              borderRadius: 10,
                              objectFit: "cover"
                            }}
                            alt="item"
                          />
                          <span
                            style={{
                              fontSize: 18,
                              alignSelf: "flex-start",
                              marginLeft: 5
                            }}
                          >
                            {lang === "en"
                              ? Aa(item?.eng_name)
                              : Aa(item?.name)}
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            {!load &&
              // items.length > 0 &&
              selectedValue === "market" &&
              showItems &&
              !showCategory &&
              !showCart &&
              !checkoutPage && (
                <div
                  style={{
                    width: "100%",
                    border: "1px solid #eeeeee",
                    padding: 10,
                    borderRadius: 5,
                    marginTop: 5
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      gap: 10
                    }}
                    className="glocery-block-menu"
                  >
                    <div
                      style={{

                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        alignItems: "center"
                      }}
                      className="zip-glocery-select"
                      onClick={handleClick}
                    >
                      <img
                        src={LocIcon}
                        style={{
                          width: 40
                        }}
                        alt="icon-logo"
                      />
                      <span
                        style={{
                          fontSize: 16,
                          color: "#000"
                        }}
                      >
                        {selectedZip}
                      </span>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        alignItems: "center",
                        height: 48,
                        justifyContent: "center",
                        border: "1px solid #e3e3e3",
                        borderRadius: 22,
                        backgroundColor: "#f7f7f7",
                        paddingLeft: 10
                      }}
                    >
                      <BsSearch size={25} color="gray" />
                      <input
                        placeholder={t("select_grocery.looking_for_item", lang)}
                        value={itemValue}
                        onChange={(e) => {
                          setItemValue(e.target.value);
                        }}
                        style={{
                          width: "95%",
                          border: "0px",
                          height: 44,
                          borderRadius: 22,
                          backgroundColor: "#f7f7f7",

                          fontSize: 18
                        }}
                      />
                    </div>
                    <div
                      style={{}}
                      className="zip-glocery-select"
                      onClick={() => {
                        if (cart_glocery.length === 0) {
                          return;
                        }
                        setShowCart(true);
                      }}
                    >
                      {cart_glocery.length === 0 && (
                        <img
                          src={CartIcon}
                          style={{
                            objectFit: "contain"
                          }}
                          alt="icon-cart"
                        />
                      )}

                      {cart_glocery.length > 0 && (
                        <div
                          style={{
                            width: 40,
                            height: 40,
                            backgroundColor: "#FF114D",
                            borderRadius: 25,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: 18,
                            fontWeight: "500",
                            color: "#fff"
                          }}
                        >
                          {cart_glocery.length}
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      marginTop: 10
                    }}
                    onClick={() => {
                      // setItems([]);
                      setShowCategory(true);
                      setShowItems(false);
                    }}
                  >
                    <BsArrowLeft style={{ marginLeft: 10 }} size={30} />
                  </div>
                  <div className="partners-block-display">
                    <div
                      style={{
                        width: "100%",
                        marginTop: 10,
                        display: "flex",
                        justifyContent: "center"
                      }}
                    >
                      {itemsNew.length === 0 && (
                        <h4>{t("select_grocery.no_article_found", lang)} </h4>
                      )}
                    </div>
                    {itemsNew
                      ?.filter((item) => {
                        if (itemValue.length > 0) {
                          return item?.name
                            ?.toLowerCase()
                            .includes(itemValue.toLowerCase());
                        }
                        return item;
                      })

                      ?.map((item) => (
                        <div className="glocery-items">
                          <img
                            src={item?.pic}
                            alt="item"
                          />
                          <span
                            style={{
                              fontSize: 20,
                              alignSelf: "flex-start"
                            }}
                          >
                            {item?.name?.length > 30
                              ? item?.name?.slice(0, 30) + "..."
                              : item?.name}
                          </span>
                          <span
                            style={{
                              fontSize: 14,
                              alignSelf: "flex-start",
                              marginLeft: 5,
                              color: "gray"
                            }}
                          >
                            {item?.description?.length > 30
                              ? item?.description?.slice(0, 30) + "..."
                              : item?.description}
                          </span>
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between"
                            }}
                          >
                            <span
                              style={{
                                fontWeight: "600",
                                marginLeft: 5
                              }}
                            >
                              {"$" +
                                item?.cost +
                                "/" +
                                item?.weight +
                                item?.weight_type}
                            </span>

                            <div
                              style={{
                                width: 30,
                                height: 30,
                                border: "2px solid #FF114D",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 10,
                                marginRight: 5,
                                backgroundColor: cart_glocery?.filter(
                                  (data) => {
                                    return data._id === item._id;
                                  }
                                )[0]
                                  ? "#FF114D"
                                  : "#fff"
                              }}
                              className="add-btn-items-gloceries"
                              onClick={() => {
                                add_remove_cart(item);
                              }}
                            >
                              {cart_glocery?.filter((data) => {
                                return data._id === item._id;
                              })[0] ? (
                                <FaMinus color={"#fff"} size={20} />
                              ) : (
                                <BsPlus color={"#FF114D"} size={25} />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            {showCart && !checkoutPage && selectedValue !== "orders" && (
              <div
                style={{
                  width: "100%",
                  border: "1px solid #eeeeee",
                  padding: 10,
                  borderRadius: 5,
                  marginTop: 5
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    marginTop: 10
                  }}
                  onClick={() => {
                    setShowCart(false);
                  }}
                >
                  <BsArrowLeft style={{ marginLeft: 10 }} size={30} />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    marginTop: 25,
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <h3
                    style={{
                      textAlign: "left",
                      display: "flex",
                      alignItems: "center",
                      marginTop: 20,
                      fontSize: 20,
                      fontWeight: "600"
                    }}
                  >
                    Adresse
                  </h3>
                  <div
                    className="input-block"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      marginTop: 0
                    }}
                  >
                    <div
                      className="btn-get-started"
                      style={{
                        backgroundColor: "#fff",
                        color: "#000",
                        border: "1px solid #cecece",
                        height: 35,
                        maxWidth: 100
                      }}
                      onClick={() => {
                        if (load) {
                          return;
                        }

                        if (user?.address?.length === 5) {
                          return openNotificationWithIcon(
                            "error",
                            t("select_grocery.errors.max_addresses", lang)
                          );
                        }

                        setOpen(true);
                      }}
                    >
                      {!load && t("buttons.add", lang)}
                      {load && <CircularProgress size={25} />}
                    </div>
                    {user?.address?.map((item, index) => (
                      <div
                        onClick={() => {
                          setDeliveryDetail(index);
                        }}
                        key={index}
                        style={{
                          maxWidth: 350,
                          border: "1px solid #cecece",
                          marginTop: 10,
                          borderRadius: 30,
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "center",
                          gap: 5,
                          padding: 10,
                          cursor: "pointer"
                        }}
                      >
                        <div
                          style={{
                            marginTop: 5
                          }}
                          className="profil-delete-btn"
                          onClick={() => {
                            return addressUpdate(index);
                          }}
                        >
                          <TiDelete size={30} color={"#ff114d"} />
                        </div>
                        <span>{Aa(item?.receiver_name)},</span>
                        <span>{Aa(item?.phone_number)},</span>
                        <span>{Aa(item?.street_name)},</span>
                        <span>{Aa(item?.line_address)},</span>
                        <span>{Aa(item?.instruction)}</span>
                        <div
                          style={{
                            width: 20,
                            height: 20,
                            borderRadius: 20,
                            border: `3px solid ${"#cecece"}`,
                            marginLeft: 10,

                            backgroundColor:
                              index === deliveryDetail ? "#ff114d" : "#fff"
                          }}
                        ></div>
                      </div>
                    ))}
                  </div>
                  <p
                    style={{
                      fontSize: 17,
                      marginTop: 30
                    }}
                  >
                    Votre commande chez{" "}
                    <b>
                      {
                        gloceries?.filter((item) => {
                          return item?._id === cart_glocery[0]?.glocery_partner;
                        })[0].company_name
                      }
                    </b>
                  </p>
                  <p
                    style={{
                      fontSize: 16
                    }}
                  >
                    {getDateInFull()}
                  </p>
                  <div
                    style={{
                      maxWidth: 460,
                      marginTop: 20
                    }}
                  >
                    {cart_glocery?.map((item) => (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: 30,
                          marginTop: 20
                        }}
                      >
                        <img
                          src={item?.pic}
                          style={{
                            width: 100,
                            height: 70,
                            borderRadius: 10,
                            objectFit: "contain"
                          }}
                          alt="img-food-glocery"
                        />
                        <div
                          style={{
                            width: 150
                          }}
                        >
                          <p
                            style={{
                              fontSize: 17
                            }}
                          >
                            {item?.name}
                          </p>{" "}
                          <div
                            style={{
                              display: "flex",
                              gap: 10
                            }}
                          >
                            <span
                              className="section-cart-right-cart-btn-span"
                              onClick={() => {
                                if (
                                  cart_glocery?.filter((data) => {
                                    return data?._id === item?._id;
                                  })[0]?.qty <= 1
                                ) {
                                  return;
                                }
                                return post_to_cart_glocery(
                                  [...cart_glocery].map((data) => {
                                    if (data?._id === item?._id)
                                      return { ...data, qty: data.qty - 1 };
                                    return { ...data };
                                  })
                                );
                              }}
                            >
                              -
                            </span>
                            <span style={{ fontWeight: "600" }}>
                              {item?.qty}
                            </span>
                            <span
                              className="section-cart-right-cart-btn-span"
                              onClick={() => {
                                if (
                                  cart_glocery?.filter((data) => {
                                    return data?._id === item?._id;
                                  })[0]?.qty >= 10
                                ) {
                                  return;
                                }
                                return post_to_cart_glocery(
                                  [...cart_glocery].map((data) => {
                                    if (data?._id === item?._id)
                                      return { ...data, qty: data.qty + 1 };
                                    return { ...data };
                                  })
                                );
                              }}
                            >
                              +
                            </span>
                          </div>
                        </div>
                        <span
                          style={{
                            fontWeight: 700,
                            fontSize: 18
                          }}
                        >
                          {"$" + (item?.cost * item?.qty)?.toFixed(2)}
                        </span>
                      </div>
                    ))}
                    <hr
                      style={{
                        marginTop: 40,
                        borderTop: "dotted 3px"
                      }}
                    />
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 15
                      }}
                    >
                      <span>{t("common.total_items", lang)}</span>
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: 18
                        }}
                      >
                        {"$" +
                          cart_glocery
                            ?.reduce((a, b) => a + b?.cost * b?.qty, 0)
                            ?.toFixed(2)}
                      </span>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 15
                      }}
                    >
                      <span>{t("common.delivery_fee", lang)}</span>
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: 18
                        }}
                      >
                        {"$" +
                          (
                            (cart_glocery
                              ?.reduce((a, b) => a + b?.cost * b?.qty, 0)
                              ?.toFixed(2) *
                              gloceries?.filter((item) => {
                                return (
                                  item?._id === cart_glocery[0]?.glocery_partner
                                );
                              })[0]?.comission_delivery) /
                            100
                          ).toFixed(2)}
                      </span>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 15
                      }}
                    >
                      <span>{t("common.total_price", lang)}</span>
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: 17,
                          backgroundColor: "#FF114D",
                          color: "#fff",
                          padding: 5,
                          borderRadius: 20
                        }}
                      >
                        {"$" +
                          (
                            cart_glocery?.reduce(
                              (a, b) => a + b?.cost * b?.qty,
                              0
                            ) +
                            (cart_glocery?.reduce(
                              (a, b) => a + b?.cost * b?.qty,
                              0
                            ) *
                              gloceries?.filter((item) => {
                                return (
                                  item?._id === cart_glocery[0]?.glocery_partner
                                );
                              })[0]?.comission_delivery) /
                              100
                          ).toFixed(2)}
                      </span>
                    </div>
                    <div
                      className="btn-see-cart"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 10,
                        width: "95%",
                        height: 50,
                        borderRadius: 25,
                        backgroundColor: "#FF114D",
                        marginTop: 20
                      }}
                      onClick={() => {
                        if (user?.address?.length === 0) {
                          return openNotificationWithIcon(
                            "error",
                            t("select_grocery.errors.shipping_address", lang)
                          );
                        }
                        loadPaymentPage();
                      }}
                    >
                      {load && <CircularProgress size={25} />}
                      {!load && (
                        <span
                          style={{
                            color: "#fff",
                            fontSize: 15,
                            fontWeight: 600
                          }}
                        >
                          {t("select_grocery.checkout", lang)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {checkoutPage && (
              <div
                style={{
                  width: "100%",
                  border: "1px solid #eeeeee",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  padding: 10,
                  borderRadius: 5,
                  marginTop: 5
                }}
              >
                <Elements
                  stripe={stripePromise}
                  options={{
                    mode: "payment",
                    payment_method_types: ["card"],
                    amount: parseInt(
                      (
                        cart_glocery?.reduce(
                          (a, b) => a + b?.cost * b?.qty,
                          0
                        ) +
                        (cart_glocery?.reduce(
                          (a, b) => a + b?.cost * b?.qty,
                          0
                        ) *
                          gloceries?.filter((item) => {
                            return (
                              item?._id === cart_glocery[0]?.glocery_partner
                            );
                          })[0]?.comission_delivery) /
                          100
                      ).toFixed(2) * 100
                    ),
                    currency: "usd",
                    // Fully customizable with appearance API.
                    appearance: {
                      /*...*/
                    }
                  }}
                >
                  <CheckoutFormGlocery
                    clear_cart={() => {
                      post_to_cart_glocery([]);
                    }}
                    order_id={orderId}
                    setCheckoutPage={setCheckoutPage}
                    setCartPage={setShowCart}
                    amount={(
                      cart_glocery?.reduce((a, b) => a + b?.cost * b?.qty, 0) +
                      (cart_glocery?.reduce((a, b) => a + b?.cost * b?.qty, 0) *
                        gloceries?.filter((item) => {
                          return item?._id === cart_glocery[0]?.glocery_partner;
                        })[0]?.comission_delivery) /
                        100
                    )?.toFixed(2)}
                  />
                </Elements>
              </div>
            )}
            {!load && selectedValue === "orders" && (
              <div
                style={{
                  width: "100%",
                  border: "1px solid #eeeeee",
                  padding: 10,
                  borderRadius: 5,
                  marginTop: 5
                }}
              >
                <div className="section-chef-menu-right-profil">
                  <div className="section-chef-menu-right-profil-inside">
                    <div
                      className="section-chef-menu-right-profil-inside-box"
                      style={{
                        marginTop: 0
                      }}
                    >
                      <div
                        className="section-chef-menu-right-profil-inside-left"
                        style={{
                          width: "100%"
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            border: "1px solid #eeeeee",
                            padding: 10,
                            borderRadius: 5,
                            marginTop: 15
                          }}
                        >
                          <p
                            style={{
                              fontSize: 16,
                              fontWeight: "600"
                            }}
                          >
                            {t("commerce.list_of_orders_2", lang)}{" "}
                          </p>
                          {order.length === 0 && (
                            <h4>{t("commerce.no_order_found", lang)} </h4>
                          )}
                          {order?.map((item, index) => (
                            <div
                              onClick={() => {}}
                              style={{
                                width: "100%",
                                marginTop: 20
                              }}
                            >
                              <Accordion
                                expanded={expanded === `panel${index + 1}`}
                                onChange={handleChange(`panel${index + 1}`)}
                              >
                                <AccordionSummary
                                  aria-controls="panel1d-content"
                                  id="panel1d-header"
                                >
                                  <Typography
                                    style={{
                                      fontSize: 15
                                    }}
                                  >
                                    {t("commerce.order_date", lang)}{" "}
                                    <b>
                                      {item?.billing_details?.delivery_date}
                                    </b>{" "}
                                    | {t("select_grocery.order_from", lang)}{" "}
                                    Chef{" "}
                                    {Aa(
                                      item?.chef_id?.firstname +
                                        " " +
                                        item?.chef_id?.lastname
                                    )}
                                    <b>
                                      {"($" +
                                        item?.billing_details?.amount +
                                        ")"}
                                    </b>{" "}
                                    |{" "}
                                    <span
                                      style={{
                                        backgroundColor:
                                          item?.status === 0
                                            ? "#dec614"
                                            : item?.status === 1
                                              ? "#3a7fcd"
                                              : item?.status === 2
                                                ? "#f66213"
                                                : item?.status === 3
                                                  ? "#2dc144"
                                                  : item?.status === 4
                                                    ? "#ff114d"
                                                    : "#c12dc1",
                                        color: "#fff",
                                        padding: 7,
                                        borderRadius: 20,
                                        fontSize: 13
                                      }}
                                    >
                                      {item?.status === 0 &&
                                        t("common.waiting_2", lang)}
                                      {item?.status === 1 &&
                                        t("common.ready_2", lang)}
                                      {item?.status === 2 &&
                                        t("common.on_way_2", lang)}
                                      {item?.status === 3 &&
                                        t("common.completed_2", lang)}
                                      {item?.status === 4 &&
                                        t("buttons.canceled_2", lang)}
                                      {item?.status === 5 &&
                                        t("common.refunded_2", lang)}
                                    </span>
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Typography
                                    style={{
                                      fontSize: 15,
                                      textAlign: "left"
                                    }}
                                  >
                                    <b>t('common.items_list', lang) </b>
                                  </Typography>
                                  {item?.food.map((item) => (
                                    <div
                                      style={{
                                        display: "flex",
                                        width: "100%",
                                        flexWrap: "wrap",
                                        marginTop: 10
                                      }}
                                    >
                                      <img
                                        alt="food-pic"
                                        src={item?.pic}
                                        style={{
                                          width: 70,
                                          height: 70,
                                          objectFit: "cover"
                                        }}
                                      />
                                      <div
                                        style={{
                                          textAlign: "left"
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: 15,
                                            marginLeft: 10
                                          }}
                                        >
                                          <b>{item.name}</b>
                                        </span>
                                        <br />
                                        <span
                                          style={{
                                            fontSize: 15,
                                            marginLeft: 10
                                          }}
                                        >
                                          <b> Qty:{item.qty}</b>
                                        </span>
                                        <br />
                                        <span
                                          style={{
                                            fontSize: 15,
                                            marginLeft: 10,
                                            color: "#ff114d"
                                          }}
                                        >
                                          <b>{"$" + item?.cost * item.qty}</b>
                                        </span>{" "}
                                        <br />
                                      </div>
                                    </div>
                                  ))}
                                </AccordionDetails>
                              </Accordion>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={openZip}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        style={{
          width: 200
        }}
      >
        <div className="menu-nav-drop-input">
          <TiLocation size={25} />
          <input
            value={newZip}
            placeholder={selectedZip}
            onChange={(e) => {
              // if (e.target.value.length > 5) {
              //   return;
              // }
              setNewZip(e.target.value);
            }}
            type="number"
          />
        </div>
      </Menu>

      <Dialog
        open={openWaring}
        onClose={() => {
          setOpenWarning(false);
        }}

      >
        <DialogContent>
          <Typography>
            {t("select_grocery.clear_cart_warning", lang)}
          </Typography>
        </DialogContent>
        <DialogActions>
          <div
            className="btn-get-started"
            style={{
              width: 80,
              fontWeight: "600"
            }}
            onClick={() => {
              post_to_cart_glocery([]);
              return setOpenWarning(false);
            }}
          >
            {t("common.yes", lang)}
          </div>
          <div
            className="btn-get-started"
            style={{
              width: 80,
              backgroundColor: "#fff",
              color: "#000",
              fontWeight: "600"
            }}
            onClick={() => {
              return setOpenWarning(false);
            }}
          >
            {t("common.no", lang)}
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}

      >
        <DialogContent>
          <div
            style={{
              minWidth: 300,
              height: "100%"
            }}
          >
            <div>
              <p
                style={{
                  textAlign: "left",
                  display: "flex",
                  alignItems: "center",
                  gap: 15,
                  fontWeight: 600,
                  marginTop: 30,
                  fontSize: 17
                }}
              >
                {t("select_grocery.add_address_title", lang)}
              </p>
              <p
                style={{
                  textAlign: "left",
                  fontSize: 15
                }}
              >
                {t("select_grocery.add_address_subtitle", lang)}{" "}
              </p>
              {/* {JSON.stringify(address)} */}
              <div className="section-chef-menu-right-address-inside-box">
                {[
                  {
                    placeholder: t("select_grocery.input.receiver_name"),
                    name: "receiver_name",
                    type: "input",
                    type_input: "text",
                    value: address?.receiver_name,
                    onChange: (e) =>
                      setAddress({
                        ...address,
                        receiver_name: e.target.value
                      })
                  },
                  {
                    placeholder: t("select_grocery.input.phone_number"),
                    name: "phone_number",
                    type: "input",
                    type_input: "number",
                    value: address?.phone_number,
                    onChange: (e) =>
                      setAddress({
                        ...address,
                        phone_number: e.target.value
                      })
                  },
                  {
                    placeholder: t("select_grocery.input.street_name"),
                    name: "street_name",
                    type: "input",
                    type_input: "text",
                    value: address?.street_name,
                    onChange: async (text) => {
                      await handleConvert(text);
                    }
                  },
                  {
                    placeholder: t("select_grocery.input.line_address"),
                    name: "line_address",
                    type: "input",
                    type_input: "text",
                    value: address?.line_address,
                    onChange: (e) =>
                      setAddress({
                        ...address,
                        line_address: e.target.value
                      })
                  },
                  {
                    placeholder: t("select_grocery.input.delivery_instruction"),
                    name: "instruction",
                    type: "input",
                    type_input: "text",
                    value: address?.instruction,
                    onChange: (e) =>
                      setAddress({
                        ...address,
                        instruction: e.target.value
                      })
                  }
                ]?.map((item) => (
                  <div
                    onClick={() => {}}
                    style={{
                      width: "100%"
                    }}
                  >
                    {item?.type === "input" && item?.name !== "street_name" && (
                      <input
                        style={{
                          height: 40
                        }}
                        className="select-address-box"
                        placeholder={item?.placeholder}
                        // placeholderStyle
                        name={item?.name}
                        value={item?.value}
                        type={item?.type_input}
                        onChange={(e) => {
                          // e.preventDefault();
                          item?.onChange(e);
                        }}
                      />
                    )}
                    {item?.name === "street_name" && (
                      <GooglePlacesAutocomplete
                        apiKey={process.env.REACT_APP_API_KEY_MAP}
                        // process env not accessible
                        selectProps={{
                          // value: item?.value,
                  onChange: (e) => {
                    item?.onChange(e?.label);
                  },
                          styles: {
                            container: (provided) => ({
                              ...provided,
                              marginTop: 20
                            }),
                            input: (provided) => ({
                              ...provided
                            }),
                            option: (provided) => ({
                              ...provided
                            })
                          },
                          placeholder: item?.placeholder
                        }}
                        apiOptions={{ language: "fr" }}
                        autocompletionRequest={
                          {
                            // componentRestrictions: {
                            //   country: ["ca"]
                            // }
                          }
                        }
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div
              className="btn-get-started"
              style={{
                backgroundColor: "#ff114d",
                width: "100%"
              }}
              onClick={() => {
                if (load) {
                  return;
                }

                return addAddress();
              }}
            >
              {!load && t("select_grocery.add", lang)}
              {load && <CircularProgress size={25} />}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SelectGlocery;

const post_user = (data) => ({
  type: POST_USER_DATA,
  data: data
});

const post_cart_glocery = (data) => ({
  type: POST_TO_CART_GLOCERY,
  data: data
});
